"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const reactflow_1 = __importStar(require("reactflow"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const constants_1 = require("../../../constants");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Article_1 = __importDefault(require("../../../networking/apis/Article"));
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const components_2 = require("./components");
const functions_1 = __importDefault(require("./functions"));
const reactflowStyle_1 = __importDefault(require("./reactflowStyle"));
const styles_1 = __importDefault(require("./styles"));
const primaryColors = ['#5963d6', '#dd577d', '#dc55c7', '#50da6a'];
const ROOT_NODE_RADIUS = (0, scale_1.scale)(154 / 2);
const CHILD_NODE_RADIUS = (0, scale_1.scale)(45);
const MindMapScreen = (props) => {
    const { nodeId } = props.route.params;
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [nodes, setNodes] = (0, reactflow_1.useNodesState)([]);
    const [edges, setEdges] = (0, reactflow_1.useEdgesState)([]);
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const [contentType, setContentType] = (0, react_1.useState)('1');
    const [nodeSelected, setNodeSelected] = (0, react_1.useState)();
    const refListData = (0, react_1.useRef)([]);
    const refMapData = (0, react_1.useRef)({ nodes: [], edges: [] });
    const refNodeDataSelected = (0, react_1.useRef)();
    const currentColor = (0, react_1.useMemo)(() => primaryColors[Math.floor(Math.random() * 3)], []);
    const isArticle = contentType === '1';
    (0, react_1.useEffect)(() => {
        if (connected) {
            initMindMap();
        }
    }, [connected]);
    const initMindMap = () => {
        Article_1.default.getArticleInheritanceMap(nodeId)
            .then((response) => {
            const listData = response.data.data;
            const hashtagDecode = decodeURIComponent(response.headers['x-central-node-hash-tag'].replace(/\+/g, ' '));
            const rootHashtags = !!hashtagDecode ? hashtagDecode.split(',') : [];
            const rootNode = {
                user_nickname: decodeURIComponent(response.headers['x-central-node-user-nickname']).replace(/\+/g, ' '),
                article_id: nodeId,
                title: decodeURIComponent(response.headers['x-central-node-title']).replace(/\+/g, ' '),
                user_thumbnail_url: decodeURIComponent(response.headers['x-central-node-user-thumbnail-url']) || '',
                posting_datetime: response.headers['x-central-node-posting-datetime'],
                user_handle: decodeURIComponent(response.headers['x-central-node-user-handle']),
                hash_tags: rootHashtags,
                has_children: 0,
                content_type: response.headers['x-central-node-content-type'],
                color: currentColor,
                stage: 0,
                radius: ROOT_NODE_RADIUS
            };
            const newNodes = [
                {
                    id: nodeId,
                    type: "nodeItem",
                    data: rootNode,
                    position: { x: 0, y: 0 },
                },
            ];
            const childPositions = (0, functions_1.default)(0, 0, ROOT_NODE_RADIUS * 2, listData.length, []);
            const newEdges = listData.map((item, index) => {
                newNodes.push({
                    id: item.article_id,
                    type: 'nodeItem',
                    data: {
                        ...item,
                        hash_tags: item.hash_tags?.map((i) => i.name),
                        color: currentColor,
                        radius: CHILD_NODE_RADIUS,
                        stage: 1,
                        content_type: response.headers['x-central-node-content-type'],
                    },
                    position: childPositions[index],
                });
                // create Edge
                return {
                    id: `eroot-${item.article_id}`,
                    source: nodeId,
                    target: item.article_id,
                };
            });
            refListData.current = [rootNode, ...listData];
            refMapData.current = { nodes: newNodes, edges: newEdges };
            refNodeDataSelected.current = rootNode;
            setNodes(newNodes);
            setEdges(newEdges);
            setNodeSelected(rootNode);
            setContentType(response.headers['x-central-node-content-type']);
        })
            .catch(() => { })
            .finally(() => {
            setLoading(false);
        });
    };
    (0, react_1.useEffect)(() => {
        const nodePressListener = new react_native_1.NativeEventEmitter().addListener(constants_1.listenerEvents.MIND_MAP_NODE_PRESS, (articleId) => {
            if (articleId == refNodeDataSelected.current?.article_id)
                return;
            if (articleId == nodeId) {
                return initMindMap();
            }
            const article = refListData.current.find(item => item.article_id === articleId);
            const parentNode = refMapData.current.nodes.find((it) => it.id == articleId);
            refNodeDataSelected.current = { ...parentNode.data };
            setNodeSelected(refNodeDataSelected.current);
            if (!!article && !!article.has_children) {
                Article_1.default.getArticleInheritanceMap(article.article_id)
                    .then(response => {
                    const listData = response.data.data;
                    const newEdges = [...refMapData.current.edges];
                    // REMOVE OTHER NODE, EDGES, ARTICLE DATA
                    refMapData.current.nodes = refMapData.current.nodes.filter((item) => {
                        if (item.data.stage >= parentNode.data.stage && item.id != parentNode.id) {
                            // REMOVE EDGES
                            const edgeIndex = newEdges.findIndex((it) => it.id == `eroot-${item.id}`);
                            if (edgeIndex != -1) {
                                newEdges.splice(edgeIndex, 1);
                            }
                            // REMOVE DATA
                            const dataIndex = refListData.current.findIndex(it => it.article_id == item.id);
                            if (dataIndex != -1) {
                                refListData.current.splice(dataIndex, 1);
                            }
                            return false;
                        }
                        return true;
                    });
                    const specialNodes = refMapData.current.nodes.map((item) => ({ x: item.position.x, y: item.position.y, radius: item.data.radius }));
                    const childPositions = (0, functions_1.default)(parentNode.position.x, parentNode.position.y, parentNode.data.radius * 3, listData.length, specialNodes);
                    listData.map((item, index) => {
                        refMapData.current.nodes.push({
                            id: item.article_id,
                            type: 'nodeItem',
                            data: {
                                ...item,
                                hash_tags: item.hash_tags?.map((i) => i.name),
                                color: currentColor,
                                radius: parentNode.data.radius * 0.9,
                                stage: parentNode.data.stage + 1,
                                contentType
                            },
                            position: childPositions[index],
                        });
                        newEdges.push({
                            id: `eroot-${item.article_id}`,
                            source: articleId,
                            target: item.article_id,
                        });
                        // @ts-ignore
                        refListData.current.push({ ...item, hash_tags: item?.hash_tags.map((i) => i.name) });
                    });
                    setNodes(refMapData.current.nodes);
                    setEdges(newEdges);
                    refMapData.current.edges = [...newEdges];
                })
                    .catch((error) => {
                    console.log('ERROR', error);
                });
            }
        });
        return () => {
            nodePressListener.remove();
        };
    }, []);
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: isArticle ? "記事継承マップ" : "自分史継承マップ", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: "#21242D" }), onLeftPress: rootNavigation_1.goBack }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.body },
            react_1.default.createElement("style", null, reactflowStyle_1.default),
            react_1.default.createElement(reactflow_1.default, { nodes: nodes, edges: edges, nodeTypes: {
                    nodeItem: components_2.NodeItem
                }, defaultViewport: {
                    x: (scale_1.width / 2),
                    y: (scale_1.height - (inset.top + (0, scale_1.scale)(200))) / 2,
                    zoom: 1
                }, maxZoom: 100, attributionPosition: "bottom-left", connectionLineType: reactflow_1.ConnectionLineType.SmoothStep, defaultEdgeOptions: {
                    type: 'straight',
                    style: {
                        stroke: currentColor,
                        strokeWidth: (0, scale_1.scale)(2)
                    }
                }, draggable: false },
                react_1.default.createElement(reactflow_1.Controls, { position: 'top-left' }))),
        react_1.default.createElement(components_2.ArticleInfo, { data: nodeSelected, isArticle: isArticle }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = MindMapScreen;
